import { createCrudEndpoints } from '../api'
import { RawTeamData } from './types'
import { managementApi, matchTrackerApi } from '../../modules/servers/api'

const tagType = 'teams' as const

export const teamsApi = matchTrackerApi.injectEndpoints({
  endpoints: (builder) => ({
    // Generic CRUD endpoints //
    ...createCrudEndpoints<RawTeamData>(tagType, builder),

    createTeam: builder.mutation<RawTeamData, Partial<RawTeamData>>({
      query: (body) => ({
        url: `${tagType}`,
        method: 'POST',
        body
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(
          managementApi.util.invalidateTags([
            { type: 'unlinkedTeams', id: 'LIST' }
          ])
        )
      }
    })
  })
})

export const {
  useTeams_getAllQuery,
  useTeams_getByIdQuery,
  useTeams_createMutation,
  useTeams_updateMutation: useUpdateTeamMutation,
  useTeams_deleteMutation: useDeleteTeamMutation,
  useLazyTeams_getAllQuery: useLazyGetAllTeamsQuery,
  useLazyTeams_getByIdQuery: useLazyGetTeamByIdQuery,
  useCreateTeamMutation
} = teamsApi
